export default __webpack_public_path__ + "static/media/proxy-selector-onboarding-carousel-web.67b306dc.png";